import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { CompletedSectionHeader } from "./CompletedSectionHeader";
import { SectionProps } from "@/types/vehicleDetails";

interface FormSectionProps extends SectionProps {
  isCompleted?: boolean;
}

export const FormSection = ({
  isOpen,
  title,
  value,
  onEdit,
  children,
  isCompleted = false
}: FormSectionProps) => (
  <div className="border border-gray-400 rounded-lg shadow-sm bg-card">
    <Collapsible open={isOpen}>
      <CollapsibleTrigger className="w-full p-3 sm:p-4 rounded-t-lg hover:opacity-70 transition-colors cursor-pointer">
        <CompletedSectionHeader
          title={title}
          value={value}
          onEdit={onEdit}
          isCompleted={isCompleted}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="px-3 sm:px-4 py-4 border-t border-gray-400">
          {children}
        </div>
      </CollapsibleContent>
    </Collapsible>
  </div>
);
